export function ScoreRange() {
    return (<input type={'range'} className={'nv-scoreRange'}/>)
}